import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Main from "./components/Main/Main";
import AdminPage from "./AdminPage";
import PrivateRoutes from './components/PrivateRoutes';
import { AuthProvider } from './AuthContext';
import { useEffect, useState } from "react";
import CookieBanner from './components/CookieBanner';
import "./App.css"

const App = () => {
    const userIsLoggedIn = false;


    return (
        <AuthProvider>
            <Router>
                <CookieBanner />
                <Routes>
                    {/* Route pour le composant Home */}
                    <Route path="/" element={<Main userIsLoggedIn={userIsLoggedIn}/>}/>

                    {/* Route pour le composant d'inscription */}
                    <Route path="/register" element={<Main signIn={true}/>}/>
			<Route path="/cards/create" element={<PrivateRoutes><AdminPage /></PrivateRoutes>} />
                </Routes>
            </Router>
        </AuthProvider>
    );
};

export default App;
